import {RootStoreModel} from "@stores/RootStore";

export const clearSearch = (rootStore: RootStoreModel) => {
    rootStore.search.setTextInput('');
    rootStore.search.setFullTextSearchResults([]);
}